"use strict";
var __importDefault = (this && this.__importDefault) || function (mod) {
    return (mod && mod.__esModule) ? mod : { "default": mod };
};
Object.defineProperty(exports, "__esModule", { value: true });
const axiosClient_1 = __importDefault(require("./axiosClient"));
const httpAPI_1 = require("gather-http-common/dist/src/public/httpAPI");
const fpHelpers_1 = require("gather-common/dist/src/public/fpHelpers");
const Logger_1 = require("./Logger");
const MATCH_PATH_PARAM = /\/:\w+(?=\/|$)/g;
const BASE_DEFAULT_PATH_PARAMS = {
    user: () => httpAPI_1.DEFAULT_PATH_PARAM_USER,
};
class HttpV2Client {
    apiBasePath;
    authManager;
    defaultPathParams;
    webWorkerClient;
    customHeaders;
    constructor(options) {
        this.apiBasePath = options.apiBasePath;
        this.authManager = options.authManager;
        this.defaultPathParams = { ...BASE_DEFAULT_PATH_PARAMS, ...options.defaultPathParams };
        this.webWorkerClient = options.webWorkerClient;
        this.customHeaders = options.customHeaders;
    }
    processPath(path, pathParams) {
        const matches = path.match(MATCH_PATH_PARAM);
        if (!matches)
            return path;
        let processedPath = path;
        for (const path of matches) {
            const param = path.slice(2);
            const paramValue = pathParams?.[param] ?? this.defaultPathParams?.[param]?.() ?? undefined;
            if (!paramValue)
                throw new Error(`No value provided for path param ${param}!`);
            processedPath = processedPath.replace(`:${param}`, encodeURIComponent(paramValue));
        }
        return processedPath;
    }
    async request(method, path, config = {}) {
        if (config?.suppressErrors) {
            return this.requestSuppressingErrors(method, path, config);
        }
        else {
            return this.requestWithoutErrorSuppression(method, path, config);
        }
    }
    async requestWithoutErrorSuppression(method, path, config = {}) {
        const finalPath = `${this.apiBasePath}/api/v2${this.processPath(path, config.params?.path)}`;
        const axiosConfig = {
            params: config.params?.query,
            adapter: config.customAdapter,
        };
        if (config.auth) {
            const authToken = await this.authManager.waitForToken();
            axiosConfig.headers = {
                authorization: `Bearer ${authToken}`,
            };
        }
        axiosConfig.headers = Object.assign(axiosConfig.headers ?? {}, this.customHeaders);
        const body = config.params?.body;
        const useWorker = config.useWorker;
        if (useWorker && !this.webWorkerClient)
            throw new Error("No WebWorkerClient initialized in HttpV2Client");
        const client = (0, fpHelpers_1.just)(useWorker ? this.webWorkerClient : axiosClient_1.default);
        switch (method) {
            case httpAPI_1.RequestMethod.Get:
                return client.get(finalPath, axiosConfig);
            case httpAPI_1.RequestMethod.Post:
                return client.post(finalPath, body, axiosConfig);
            case httpAPI_1.RequestMethod.Patch:
                return client.patch(finalPath, body, axiosConfig);
            case httpAPI_1.RequestMethod.Put:
                return client.put(finalPath, body, axiosConfig);
            case httpAPI_1.RequestMethod.Delete:
                return client.delete(finalPath, { data: body, ...axiosConfig });
            default:
                throw new Error(`Unrecognized method ${method}`);
        }
    }
    async requestSuppressingErrors(method, path, config = {}) {
        try {
            return await this.requestWithoutErrorSuppression(method, path, config);
        }
        catch (e) {
            Logger_1.Logger.error(`HttpV2Client error in ${method} ${path}: ${e}`);
            return;
        }
    }
    setApiBasePath(apiBasePath) {
        this.apiBasePath = apiBasePath;
    }
    async get(path, config = {}) {
        return this.request(httpAPI_1.RequestMethod.Get, path, config);
    }
    async post(path, config = {}) {
        return this.request(httpAPI_1.RequestMethod.Post, path, config);
    }
    async patch(path, config = {}) {
        return this.request(httpAPI_1.RequestMethod.Patch, path, config);
    }
    async put(path, config = {}) {
        return this.request(httpAPI_1.RequestMethod.Put, path, config);
    }
    async delete(path, config = {}) {
        return this.request(httpAPI_1.RequestMethod.Delete, path, config);
    }
}
exports.default = HttpV2Client;
//# sourceMappingURL=httpV2Client.js.map